module.exports = __webpack_public_path__ + "static/media/pic_2.42b93d95.jpg";